import React from 'react';

import darkAlleyIcon from 'src/public/img/undraw-dark-alley-hl-3-o.svg';

import * as S from '../../stepComponents/styles';

const listElements = [
    'Drinking or using drugs to cope',
    'Withdrawing from friends and family',
    'Eating too much or not enough',
    'Working too much',
    'Getting into fights or other violent behaviors',
    'Never talking or thinking about the event',
    'Not taking care of yourself',
    'Blaming yourself or others',
    'Doing risky things (e.g., driving recklessly, drinking too much)',
];

export const WhatDoesNotHelpStep: React.SFC = () => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading>What doesn’t help?</S.StepHeading>
            <S.BulletList>
                {listElements.map(element => (
                    <S.BulletListElement key={element}>{element}</S.BulletListElement>
                ))}
            </S.BulletList>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon iconUrl={darkAlleyIcon} />
        </S.ContentColumn>
    </S.ContentRow>
);
